export enum JobPostingStatusEnum {
  Posted = 'posted',
  Closed = 'closed',
  Draft = 'draft'
}

export const JOB_POSTING_STATUS_RECORD: Record<JobPostingStatusEnum, string> = {
  [JobPostingStatusEnum.Posted]: 'Posted',
  [JobPostingStatusEnum.Closed]: 'Closed',
  [JobPostingStatusEnum.Draft]: 'Draft'
};
